module.exports = __webpack_public_path__ + "assets/img/mixed.74d23af8.svg";